import { lazy } from "react";

import { AgentDesktopPaths } from "Pages/agentDesktop/paths";

import AgentSettings from "../AgentSettingsRoutingPage";
import { AgentSettingsPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const AgentSettingsRedirect = lazy(() => import("./AgentSettingsRedirect/AgentSettingsRedirect"));
const AgentSettingsIntegrationsPage = lazy(
    () => import("./AgentSettingsIntegrationsPage/AgentSettingsIntegrationsPage")
);
const AgentSettingsRecordingsPage = lazy(() => import("./AgentSettingsRecordingsPage/AgentSettingsRecordingsPage"));

export const agentDesktopSettingsRoute: RegalRouteObject = {
    path: `${AgentDesktopPaths.mySettings}/*`,
    element: <AgentSettings />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <AgentSettingsRedirect />,
        },
        {
            path: AgentSettingsPaths.integrations,
            element: <AgentSettingsIntegrationsPage />,
        },
        {
            path: AgentSettingsPaths.recordings,
            element: <AgentSettingsRecordingsPage />,
        },
    ],
};
